"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_react_1 = require("mobx-react");
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const Button_1 = __importDefault(require("../../common/js/atoms/Button"));
const GlobalModal_1 = require("../../common/js/components/GlobalModal");
const AuthorizationScopes_1 = __importDefault(require("../../common/js/enums/AuthorizationScopes"));
const ButtonSize_1 = __importDefault(require("../../common/js/enums/ButtonSize"));
const ButtonVariant_1 = __importDefault(require("../../common/js/enums/ButtonVariant"));
const Zupicons_1 = __importDefault(require("../../common/js/enums/Zupicons"));
const noop_1 = require("../../common/js/helper/noop");
const translation_1 = require("../../common/js/helper/translation");
const AuthorizationStore_1 = __importDefault(require("../../common/js/stores/AuthorizationStore"));
const MessageModal_1 = __importDefault(require("../components/MessageModal"));
const Paths_1 = require("../constants/Paths");
const cart_1 = require("../helper/cart");
const history_1 = require("../helper/history");
const product_1 = require("../helper/product");
const ShopwareCart_1 = __importDefault(require("../stores/ShopwareCart"));
const ShopwareContext_1 = __importDefault(require("../stores/ShopwareContext"));
const AddToCartButton = ({ machineIds = [], additionalSeatsCount, buttonSize = ButtonSize_1.default.default, buttonText = (0, translation_1.t)('add_to_cart_button.label.consumable'), buttonVariant = ButtonVariant_1.default.primary, className, disabled, history, onClick = noop_1.noop, productId, quantity, }) => {
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [icon, setIcon] = (0, react_1.useState)(Zupicons_1.default.shoppingCart);
    const isDisabled = loading || disabled;
    const isSoftwareProduct = (0, product_1.isSoftware)(additionalSeatsCount ?? null);
    if (AuthorizationStore_1.default.auth0?.isAuthenticated && !AuthorizationStore_1.default.hasScope(AuthorizationScopes_1.default.CART_UPDATE)) {
        return null;
    }
    return (react_1.default.createElement(Button_1.default, { variant: buttonVariant, size: buttonSize, text: buttonText, icon: icon, className: className, disabled: isDisabled, loading: loading, onClick: (event) => {
            onClick(event);
            if (!AuthorizationStore_1.default.auth0?.isAuthenticated) {
                return (0, history_1.pushHistory)(history, Paths_1.PATH_LOGIN, { returnTo: location.pathname });
            }
            if (ShopwareContext_1.default.contextExtension?.massiveConsumablesCheckoutDeactivated && !isSoftwareProduct) {
                const title = (0, translation_1.t)('modal.consumables_checkout_deactivated.title', {
                    channel: AuthorizationStore_1.default.channelId,
                });
                const body = (0, translation_1.t)('modal.consumables_checkout_deactivated.text', {
                    channel: AuthorizationStore_1.default.channelId,
                });
                (0, GlobalModal_1.showModal)({
                    component: MessageModal_1.default,
                    props: { title, body },
                });
                return;
            }
            const machineIdsToAdd = machineIds.length > 0 ? machineIds : [undefined];
            const products = machineIdsToAdd.map((machineId) => ({
                additionalSeatsCount,
                id: productId,
                machineId,
                quantity,
            }));
            setLoading(true);
            ShopwareCart_1.default
                .addProducts(products, machineIds.length > 0)
                .then(() => {
                setIcon(Zupicons_1.default.check);
                setLoading(false);
                setTimeout(() => {
                    setIcon(Zupicons_1.default.shoppingCart);
                }, 1000);
                if (isSoftwareProduct) {
                    (0, history_1.pushHistory)(history, Paths_1.PATH_SHOP_CHECKOUT);
                }
            })
                .catch((response) => {
                return (0, cart_1.handleAddToCartErrorResponse)(response);
            })
                .finally(() => setLoading(false));
        } }));
};
exports.default = (0, react_router_dom_1.withRouter)((0, mobx_react_1.observer)(AddToCartButton));
